import { animate, useReducedMotion } from "framer-motion";
import { useEffect, useState } from "react";

/**
 * Counts up from `from` to `to` when `start` is true. Respects reduced-motion
 * (jumps straight to the target). Shared by the hero illustration and the
 * landing-page stats band.
 */
export default function AnimatedNumber({ from = 0, to, duration = 1.2, start = true }) {
  const reduceMotion = useReducedMotion();
  const [value, setValue] = useState(from);

  useEffect(() => {
    if (!start) return undefined;
    if (reduceMotion) {
      setValue(to);
      return undefined;
    }
    const controls = animate(from, to, {
      duration,
      ease: "easeOut",
      onUpdate: (v) => setValue(Math.round(v)),
    });
    return () => controls.stop();
  }, [from, to, duration, start, reduceMotion]);

  return <span>{value}</span>;
}
